
export default function FAQHero() {
  return (
    <section className="relative bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 text-white py-24 mt-20">
      <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-black/20"></div>
      <div className="relative max-w-7xl mx-auto px-6 lg:px-8 text-center">
        <h1 className="text-5xl lg:text-6xl font-bold mb-6">
          Areas We Serve
        </h1>
        <p className="text-xl lg:text-2xl text-slate-200 max-w-4xl mx-auto leading-relaxed">
          Professional AutoCAD layout and formwork detailing services across the entire Lower
          Mainland. From Vancouver to the Fraser Valley, we provide expert construction technical
          documentation for BC projects.
        </p>
      </div>
    </section>
  );
}
